import { render, staticRenderFns } from "./GameAssets.vue?vue&type=template&id=8e79b872&scoped=true"
import script from "./GameAssets.vue?vue&type=script&lang=js"
export * from "./GameAssets.vue?vue&type=script&lang=js"
import style0 from "./GameAssets.vue?vue&type=style&index=0&id=8e79b872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e79b872",
  null
  
)

export default component.exports